import { AccountValidator } from "./AccountValidator";
import { MyPageHelper } from "./MyPageHelper";
import { ELoginStatus } from "./ELoginStatus";
import { ELoginType } from "./ELoginType";
import { EPortalType } from "./EPortalType";
import { ILoginResult } from "./ILoginResult";
import { IRegisterResult } from "./IRegisterResult";
import { BASE_URL, DEV_BASE_URL } from "../data_provider/Config";
import { isDev, path } from "../components/common/Common";
import DataProvider from "../data_provider/DataProvider";

/**
 * @author sukim91
 * @date 2022-10-06 14:35
 * @remark AccountManager
 * @props None
 */
export class AccountManager {
	private static instance: AccountManager;

	private validator: AccountValidator;
	private mypage: MyPageHelper;

	constructor() {
		this.validator = new AccountValidator();
		this.mypage = new MyPageHelper();
	}

	public static getInstance() {
		if (!AccountManager.instance) {
			AccountManager.instance = new AccountManager();
		}

		return AccountManager.instance;
	}

	/** @returns boolean */
	public isLoggedIn() {
		if (!this.validator.isValidCookies()) return false;

		const isLoggedIn = this.validator.getCookieWithoutEncoding("KMLN");

		return isLoggedIn;
	}

	/** void */
	public initialize() {
		AccountManager.instance = new AccountManager();
	}

	/** void */
	public expressLoginMode() {}

	/** void */
	private showLoginStatus(status: ELoginStatus) {
		if (status === ELoginStatus.LOGIN) {
		} else {
		}
	}

	/** void */
	// 소셜 로그인에만 사용 (일반로그인은 generalLogin으로 분리)
	public async login(type: ELoginType): Promise<ILoginResult | { flag: false; message: string }> {
		let portalType = null;

		switch (type) {
			case ELoginType.LOCAL:
				break;
			case ELoginType.GOOGLE:
				portalType = EPortalType.GOOGLE;
				break;
			case ELoginType.NAVER:
				portalType = EPortalType.NAVER;
				break;
			case ELoginType.KAKAO:
				portalType = EPortalType.KAKAO;
				break;
			case ELoginType.FACEBOOK:
				portalType = EPortalType.FACEBOOK;
				break;
		}

		if (!portalType) {
			/** 일반로그인 로직(사용하지 않음)**/

			const id = ""; // 컴포넌트에서 값 획득
			const password = ""; // 컴포넌트에서 값 획득

			const data = await this.generalLogin_old(id, password);

			if (data.flag) {
				const expire = new Date();
				expire.setMonth(expire.getMonth() + 1);

				const setCookieWithEncoding = this.validator.setCookieWithEncoding;
				const setCookieWithoutEncoding = this.validator.setCookieWithoutEncoding;

				const name = data.result;
				// $('input:checkbox[id=\'idsave\']').is(':checked') ? 'true' : 'false'; // 컴포넌트에서 값 획득
				const saveid = Math.floor(Math.random() * 2) === 0 ? "false" : "true";
				// $('input:checkbox[id=\'autologin\']').is(':checked') ? 'true' : 'false'; // 컴포넌트에서 값 획득
				const autologin = Math.floor(Math.random() * 2) === 0 ? "false" : "true";

				//이메일 저장
				setCookieWithEncoding("KMSD", saveid, expire.getTime());
				//자동로그인
				setCookieWithEncoding("KMAL", autologin, expire.getTime());
				//로그인 플렛폼
				setCookieWithoutEncoding("KMPF", "LOCAL", expire.getTime());
				// 1. 사용자 이름
				// 2. 사용자 아이디
				// 3. 로그인 여부
				if (autologin === "true") {
					setCookieWithEncoding("KMNM", name, expire.getTime()); // 1
					setCookieWithoutEncoding("KMUI", id, expire.getTime()); // 2
					setCookieWithoutEncoding("KMLN", "1", expire.getTime()); // 3
				} else {
					setCookieWithEncoding("KMNM", name); // 1
					setCookieWithoutEncoding("KMUI", id); // 2
					setCookieWithoutEncoding("KMLN", "1"); // 3
				}

				// 아이디를 저장할 경우
				if (saveid === "true") {
					setCookieWithoutEncoding("KMSI", id, expire.getTime());
				} else {
					setCookieWithoutEncoding("KMSI", id, expire.getTime() - 86400000 * 60);
				}

				return data;
			} else {
				return {
					flag: false,
					message: data.result === "1" ? "아이디가 활성화 되지 않았습니다.\n가입하신 이메일에서 계정을 인증해주시기 바랍니다." : "가입하지 않은 아이디거나, 잘못된 비밀번호입니다.",
				};
			}
		} else {
			/** 간편로그인 로직(사용중) **/

			const data = await this.Callback(portalType);
			if (data.flag) {
				// 응답이 정상일 경우
				// 팝업에서 실행되는 함수: CallbackOnPopup
				window.open(data.result, "포탈 로그인", "width=450, height=800, toolbar=no, menubar=no, scrollbars=no, resizable=yes");
			} else {
				// 비정상일 경우
				return { flag: false, message: "오류가 발생했습니다." };
			}
			return data;
		}
	}

	/** @deprecated **/
	/** @returns Promise<ILoginResult> */
	private async generalLogin_old(id: string, password: string) {
		const url = `/session`;

		/** 모두의지도 기존 localLogin session API */
		const query = {
			process: "login",
			id: id,
			password: password,
			saveid: "false", // $('input:checkbox[id=\'idsave\']').is(':checked') ? 'true' : 'false'; // 컴포넌트에서 값 획득
			autologin: "false", // $('input:checkbox[id=\'autologin\']').is(':checked') ? 'true' : 'false'; // 컴포넌트에서 값 획득
			platform: "Locallogin",
		};

		const res = await fetch(url, {
			method: "POST",
			mode: "cors",
			headers: {
				"Content-Type": "application/json",
			},
			redirect: "follow",
			referrerPolicy: "no-referrer",
			body: JSON.stringify(query),
		});

		const json: Promise<ILoginResult> = await res.json();

		return json;
	}

	// 간편 로그인 API | kmy | 25.03.26 | 내용 추가
	/** @returns Promise<ILoginResult> */
	private async Callback(type: EPortalType) {
		const base_url = isDev() ? DEV_BASE_URL : BASE_URL;
		const url = base_url + `/session?process=login&platform=${type}`;

		const res = await fetch(url, {
			method: "GET",
			mode: "cors",
			headers: { "Content-Type": "application/json" },
			redirect: "follow",
			referrerPolicy: "no-referrer",
		});

		const json: Promise<ILoginResult> = await res.json();
		return json;
	}

	/**
	 * @remark 팝업에서 추가 실행되는 로그인 과정을 위해 생성한 함수
	 * void
	 * 사용 중인 곳 없음
	 */
	private async CallbackOnPopup(type: EPortalType) {
		const search = window.location.search;
		const urlParams = new URLSearchParams(search);

		const code = urlParams.get("code");
		const state = urlParams.get("state");

		const url = `/session`;

		const query = {
			process: "login",
			platform: type,
			code: code,
			state: state,
		};

		const res = await fetch(url, {
			method: "POST",
			mode: "cors",
			headers: {
				"Content-Type": "application/json",
			},
			redirect: "follow",
			referrerPolicy: "no-referrer",
			body: JSON.stringify(query),
		});

		const data = await res.json();

		if (data.flag) {
			const { isReg, auth, platform } = data.result;

			let authJson = null;

			switch (platform) {
				case "naver":
					authJson = this.parseNaverJson(auth);
					break;
				case "google":
					authJson = this.parseGoogleJson(auth);
					break;
				case "kakao":
					authJson = this.parseKakaoJson(auth);
					break;
				case "facebook":
					authJson = this.parseFacebookJson(auth);
					break;
			}

			if (isReg && authJson) {
				// 회원가입이 되어있을 경우
				const setCookieWithEncoding = this.validator.setCookieWithEncoding;
				const setCookieWithoutEncoding = this.validator.setCookieWithoutEncoding;

				setCookieWithEncoding("KMNM", authJson.name);
				setCookieWithoutEncoding("KMUI", `${authJson.email}@${authJson.host}`);
				setCookieWithEncoding("KMSD", "false");
				setCookieWithEncoding("KMAL", "false");
				setCookieWithoutEncoding("KMLN", "1");
				setCookieWithoutEncoding("KMPF", platform);

				window.location.href = "/";

				// self.close();
			} else if (authJson) {
				// 회원이 아닐 경우
				if (!authJson.email) {
					if (type == "facebook") {
						alert("이메일 정보 불러오기에 실패했습니다.\n이메일 정보수집에 동의해주시기 바랍니다.");

						window.location.href =
							"https://www.facebook.com/v11.0/dialog/oauth" +
							"?response_type=code" +
							"&client_id=805308050185101" +
							"&redirect_uri=" +
							encodeURIComponent("https://modoomap.com/login/facebook.html") +
							"&auth_type=rerequest" +
							"&scope=email";
					} else {
						alert("이메일 정보 불러오기에 실패했습니다.\n관리자에게 문의해주시기 바랍니다.");

						// self.close();
					}

					return;
				}
			}
		} else {
			// 인증이 유효하지 않을 경우
			alert("유효하지 않은 계정입니다.");
		}
	}

	/** @returns object */
	private parseNaverJson(json: any) {
		const [email, host] = json.response.email.split("@");

		const sex = (function () {
			if (json.response.gender) {
				return json.response.gender === "M" ? 1 : 0;
			} else {
				return null;
			}
		})();

		const year = json.response.birthyear ? json.response.birthyear : null;
		const [month, day] = json.response.birthday ? json.response.birthday.split("-") : [null, null];

		return {
			email: email,
			host: host,
			password: json.response.email,
			platformName: "NAVER",
			name: json.response.name ? json.response.name : null,
			sex: sex,
			year: year,
			month: month,
			day: day,
		};
	}

	/** @returns object */
	private parseGoogleJson(json: any) {
		const [email, host] = json.email.split("@");

		return {
			email: email,
			host: host,
			password: json.email,
			platformName: "GOOGLE",
			name: json.name ? json.name : null,
			sex: null,
			year: null,
			month: null,
			day: null,
		};
	}

	/** @returns object */
	private parseKakaoJson(json: any) {
		const [email, host] = json.kakao_account.email.split("@");

		const sex = (function () {
			if (json.kakao_account.has_gender && json.kakao_account.gender) {
				return json.kakao_account.gender === "male" ? 1 : 0;
			} else {
				return null;
			}
		})();

		const month = json.kakao_account.birthday ? json.kakao_account.birthday.substring(0, 2) : null;
		const day = json.kakao_account.birthday ? json.kakao_account.birthday.substring(2) : null;

		const authJson = {
			email: email,
			host: host,
			password: json.kakao_account.email,
			platformName: "KAKAO",
			name: json.kakao_account.profile.nickname ? json.kakao_account.profile.nickname : null,
			sex: sex,
			year: null,
			month: month,
			day: day,
		};

		return authJson;
	}

	/** @returns object */
	private parseFacebookJson(json: any) {
		const email = json && json.email ? json.email.split("@")[0] : null;
		const host = json && json.email ? json.email.split("@")[1] : null;
		const password = json && json.email ? json.email : null;
		const name = json && json.email ? json.name : null;

		return {
			email: email,
			host: host,
			password: password,
			platformName: "FACEBOOK",
			name: name,
			sex: null,
			year: null,
			month: null,
			day: null,
		};
	}

	/** @returns Promise<any> */
	public async getAccountInfo() {
		const res = await DataProvider.GetUserInfo();
		if (res.flag) {
			return res;
		} else {
			console.error("Failed to get account info:");
			return null;
		}
	}

	/** @returns Promise<boolean> */
	public async isProUser() {
		const userInfo = await this.getAccountInfo();
		const gradeCode = userInfo ? userInfo.result.membership.gradeCode : -1;

		if (gradeCode === 2) return true;

		return false;
	}

	/** @returns Promise<boolean> */
	public async isAdminUser() {
		if (!this.isLoggedIn()) return false;
		const userInfo = await this.getAccountInfo();
		const gradeCode = userInfo ? userInfo.result.membership.gradeCode : -1;

		return gradeCode === 0 ? true : false;
	}

	// 회원가입 API | kmy | 25.03.21
	/** @returns Promise<IRegisterResult> */
	public async registerUser(registInfo: any) {
		const base_url = isDev() ? DEV_BASE_URL : BASE_URL;
		const url = base_url + `/user?process=create`;

		const res = await fetch(url, {
			method: "POST",
			mode: "cors",
			headers: { "Content-Type": "application/json" },
			redirect: "follow",
			referrerPolicy: "no-referrer",
			body: JSON.stringify(registInfo),
		});

		const result: Promise<IRegisterResult> = await res.json();

		return result;
	}

	// 계정 유무 확인 API | kmy | 25.03.24
	/** @returns Promise<IRegisterResult> */
	public async checkUserExists(userId: String) {
		const base_url = isDev() ? DEV_BASE_URL : BASE_URL;
		const url = base_url + `/user?process=duplicate&userid=${userId}`;

		const res = await fetch(url, {
			method: "GET",
			mode: "cors",
			headers: { "Content-Type": "application/json" },
			redirect: "follow",
			referrerPolicy: "no-referrer",
		});

		const result: Promise<IRegisterResult> = await res.json();

		return result;
	}

	// 일반 로그인 API | kmy | 25.03.24
	/** @returns Promise<IRegisterResult> */
	public async generalLogin(logInUserInfo: any) {
		const base_url = isDev() ? DEV_BASE_URL : BASE_URL;
		const url = base_url + `/session?process=login&platform=Locallogin`;

		const res = await fetch(url, {
			method: "POST",
			mode: "cors",
			headers: { "Content-Type": "application/json" },
			redirect: "follow",
			referrerPolicy: "no-referrer",
			body: JSON.stringify(logInUserInfo),
			// hmchoi
			credentials: "include",
		});

		const result: Promise<IRegisterResult> = await res.json();

		return result;
	}

	// 소셜 로그인 API | kmy | 25.03.24
	/** @returns Promise<IRegisterResult> */
	public async portalLoginCallback(param: any) {
		const base_url = isDev() ? DEV_BASE_URL : BASE_URL;
		const url = base_url + `/session?process=login&platform=${param.platform}&code=${param.code}&state=${param.state}`; // 로그인 토큰발행용 URL

		const res = await fetch(url, {
			method: "POST",
			mode: "cors",
			headers: { "Content-Type": "application/json" },
			redirect: "follow",
			referrerPolicy: "no-referrer",
			body: JSON.stringify(param),
		});

		const data = await res.json();

		if (data.flag) {
			const { isReg, auth, platform } = data.result;
			let authJson = null;

			switch (platform) {
				case "NAVER":
					authJson = this.parseNaverJson(auth);
					break;
				case "GOOGLE":
					authJson = this.parseGoogleJson(auth);
					break;
				case "KAKAO":
					authJson = this.parseKakaoJson(auth);
					break;
				case "FACEBOOK":
					authJson = this.parseFacebookJson(auth);
					break;
			}

			if (isReg && authJson) {
				// 회원가입이 되어있을 경우

				// 소셜 로그인 시 쿠키 중복 등록 주석 처리|| 250829 || smyun
				// const setCookieWithEncoding = this.validator.setCookieWithEncoding;
				// const setCookieWithoutEncoding = this.validator.setCookieWithoutEncoding;

				// setCookieWithEncoding("KMNM", authJson.name);
				// setCookieWithoutEncoding("KMUI", `${authJson.email}@${authJson.host}`);
				// setCookieWithEncoding("KMSD", "false");
				// setCookieWithEncoding("KMAL", "false");
				// setCookieWithoutEncoding("KMLN", "1");
				// setCookieWithoutEncoding("KMPF", platform);

				// document.cookie = "KMLN=1; Path=/;"; // 로그인 쿠키 주입(useCookie 사용 불가) // 로그인 감지를 백엔드 쿠키 확인 방식으로 변경했으므로 불필요 | smyun | 250906

				if (window.opener) {
					// 새 창에서 기존 창으로 리다이렉트 요청
					window.opener.location.reload();
					// TODO: 로그인 완료 신호와 함게 보낸후 메인에서 처리
					// window.opener.postMessage({ type: "AUTH_DONE" }, "https://modoomap.com");
				}
				window.close();
			} else if (authJson) {
				// 회원이 아닐 경우
				localStorage.setItem("authJson", JSON.stringify(authJson)); // 회원가입 시에 사용 하도록 사용자 정보 저장

				if (!authJson.email) {
					if (param.platform == "FACEBOOK") {
						alert("이메일 정보 불러오기에 실패했습니다.\n이메일 정보수집에 동의해주시기 바랍니다.");

						window.location.href =
							"https://www.facebook.com/v11.0/dialog/oauth" +
							"?response_type=code" +
							"&client_id=805308050185101" +
							"&redirect_uri=" +
							encodeURIComponent("https://modoomap.com/login/facebook.html") +
							"&auth_type=rerequest" +
							"&scope=email";
					} else {
						alert("이메일 정보 불러오기에 실패했습니다.\n관리자에게 문의해주시기 바랍니다.");
					}
				}
				// 새 창 닫기
				window.close();
				if (window.opener) {
					// 새 창에서 기존 창으로 리다이렉트 요청
					window.opener.location.href = `${path.SIGNUP_ADD_INFO}?platform=${platform}`;
				}
			}
			return data;
		} else {
			// 인증이 유효하지 않을 경우
			alert("유효하지 않은 계정입니다.");
		}
	}
}
